import React from "react";
import styled, { keyframes } from "styled-components";

// List of logos
import sdsc from "../../logos/SDSC.png";
import ultra from "../../logos/Ultra.png";
import USDevcon from "../../logos/USDEVCON.png";
import bloom from "../../logos/Bloomberg.png";

// Array of logo image paths or URLs
const logoData = [
  { src: sdsc, width: 250, height: 100 },
  { src: bloom, width: 250, height: 100 },
  { src: ultra, width: 250, height: 100 },
  { src: USDevcon, width: 250, height: 100 },
];

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const LogoGroupWrapper = styled.div`
  ${(props) =>
    props.isFilterActive &&
    `
      background-color: rgba(0, 0, 0, 0);
      filter: grayscale(100%);
    `}

  padding: 20px;
  display: flex;
  overflow: hidden;
  width: auto;
`;

const LogoScroller = styled.div`
  display: flex;
  justify-content: space-between;
  animation: ${scroll} 20s linear infinite;
`;

const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  margin: 0 50px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
  }
`;

const TechLogoGroup = ({ isFilterActive }) => {
  // Duplicate the logos to create a seamless loop
  const duplicatedLogos = [...logoData, ...logoData];

  return (
    <LogoGroupWrapper isFilterActive={isFilterActive}>
      <LogoScroller>
        {duplicatedLogos.map((logo, index) => (
          <StyledLogoImage
            key={index}
            src={logo.src}
            alt={`Logo ${index + 1}`}
            width={logo.width}
            height={logo.height}
          />
        ))}
      </LogoScroller>
    </LogoGroupWrapper>
  );
};

const StyledLogoImage = styled(LogoImage)`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default TechLogoGroup;

